import AcademicCalendar from './calendar.png'
import FinalExamTimes from './final-exam-times.png'


export const renderCalendar = () => {
	return (
		<div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
		<img src={AcademicCalendar} alt='Lewis University 2025 Academic Calendar' width= '1024'/>
	</div>
	)
}

export const renderFinalExamTimes = () => {
	return (
		<div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
		<img src={FinalExamTimes} alt='Lewis University 2025 Final Exam Times' width= '1024'/>
	</div>
	)
}